module.exports = __webpack_public_path__ + "static/media/Video_caption_4.feae2dfe.png";